import React from 'react';
import { isObject } from 'lodash';

function getItemNodeAndConfig(result) {
  var node = /*#__PURE__*/React.createElement(React.Fragment, null);
  var config = {};
  if ( /*#__PURE__*/React.isValidElement(result)) {
    node = result;
  } else if (isObject(result) && 'node' in result) {
    var _node = result.node,
      _a = result.config,
      _config = _a === void 0 ? {} : _a;
    node = _node;
    config = _config;
  }
  return {
    node: node,
    config: config
  };
}

export { getItemNodeAndConfig as default };
